import { createContext, useContext } from "react";

export const GlobalContext = createContext({
  hl: null,
  setHl: () => {}
});

export const useGlobal = () => useContext(GlobalContext);